import {Checkbox, Typography} from '@sollapay/ui/components';
import {cn} from '@sollapay/ui/lib';
import {useTranslation} from 'react-i18next';

import type {FC} from 'react';

/** `onBehalfOf` names the trustee when the caller approves in their name, as an operator. */
export interface IdentityChangeApprovalProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  onBehalfOf?: string;
  disabled?: boolean;
}

export const IdentityChangeApproval: FC<IdentityChangeApprovalProps> = ({
  checked,
  onCheckedChange,
  onBehalfOf,
  disabled = false
}) => {
  const {t} = useTranslation('trustAccounts');

  return (
    <label
      htmlFor="identity-change-approval"
      data-slot="identity-change-approval"
      className={cn(
        'flex items-start gap-3 rounded-xl border border-border px-4 py-3',
        disabled ? 'cursor-default' : 'cursor-pointer'
      )}
    >
      <Checkbox
        id="identity-change-approval"
        checked={checked}
        onCheckedChange={value => onCheckedChange(value === true)}
        disabled={disabled}
        className="mt-0.5 shrink-0"
      />
      <Typography size="sm" className="leading-relaxed whitespace-normal">
        {onBehalfOf === undefined
          ? t('view.buyers.editBuyerModal.identityChangeApproval')
          : t('view.buyers.editBuyerModal.identityChangeApprovalOnBehalf', {
              lawyerName: onBehalfOf
            })}
      </Typography>
    </label>
  );
};
